import { Typography } from '@musinsa/mds';
import { twMerge } from 'tailwind-merge';

interface EmptyCouponGoodsViewProps {
  className?: string;
}

/**
 * 쿠폰 적용 상품 PLP 의 empty state. 방문자/판매자 페이지 공통.
 * 선택된 카테고리·정렬에 해당하는 상품이 0건일 때 카테고리 탭 + 정렬 행 아래 영역에 노출.
 */
export const EmptyCouponGoodsView = ({ className }: EmptyCouponGoodsViewProps) => (
  <div
    className={twMerge(
      'flex grow flex-col items-center justify-center bg-gray-100 px-4 py-10',
      className,
    )}
  >
    <Typography variant="body14pxMed">판매중인 상품이 없습니다.</Typography>
  </div>
);
